var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRedCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5547 9.93164C18.5547 14.9022 14.5253 18.9316 9.55469 18.9316C4.58412 18.9316 0.554688 14.9022 0.554688 9.93164C0.554688 4.96108 4.58412 0.931641 9.55469 0.931641C14.5253 0.931641 18.5547 4.96108 18.5547 9.93164ZM4.84758 14.6387C4.45706 14.2482 4.45706 13.6151 4.84758 13.2245L8.14047 9.93164L4.84758 6.63875C4.45706 6.24822 4.45706 5.61506 4.84758 5.22453C5.23811 4.83401 5.87127 4.83401 6.26179 5.22453L9.55469 8.51743L12.8476 5.22453C13.2381 4.83401 13.8713 4.83401 14.2618 5.22453C14.6523 5.61506 14.6523 6.24822 14.2618 6.63875L10.9689 9.93164L14.2618 13.2245C14.6523 13.6151 14.6523 14.2482 14.2618 14.6387C13.8713 15.0293 13.2381 15.0293 12.8476 14.6387L9.55469 11.3459L6.26179 14.6387C5.87127 15.0293 5.23811 15.0293 4.84758 14.6387Z",
    fill: "#FF4033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedCircleIcon);
export default __webpack_public_path__ + "static/media/cross-red-circle-icon.137a0f76dc9a42e54489ccaf9c2775d9.svg";
export { ForwardRef as ReactComponent };